"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const IntegrationElementContext = createContext({});
function useIntegrationElementContext() {
  return useContext(IntegrationElementContext);
}

export { IntegrationElementContext, useIntegrationElementContext };
